module.exports = __webpack_public_path__ + "img/visitor-card.047ef713.png";